export { default as GooglePlayIcon } from '~icons/mdi/google-play';
